// extracted by mini-css-extract-plugin
export default {"tabsListItem":"TabsListItem_tabsListItem__m8MFL","active":"TabsListItem_active__gDtC8"};